import React from 'react';
import { Rect } from 'react-konva';

export type ShadowProps = {
  isVisible: boolean,
  shadowHeight: number,
  shadowSize: number,
  shadowBlur: number,
  width: number,
  height: number,
  corner: number,
};

function Shadow({ isVisible, shadowHeight, shadowSize, shadowBlur, width, corner }: ShadowProps) {
  return (
    <Rect
      perfectDrawEnabled={false}
      hitStrokeWidth={0}
      shadowForStrokeEnabled={false}
      listening={false}
      fill="rgba(255,255,255,1)"
      visible={isVisible}
      shadowColor={'black'}
      shadowOpacity={0.5}
      shadowBlur={shadowBlur}
      shadowOffset={{ x: shadowSize, y: shadowSize }}
      width={width}
      height={shadowHeight}
      cornerRadius={corner}
    />
  );
}
export default Shadow;
